<template>
  <!-- Artículos del blog en las páginas interiores (Blog y "También le puede interesar") -->
  <div class="n2-lista n2-lista--articulos" :class="{ 'n2-lista--una': columnas === 1 }" :style="{ '--n2-columnas': columnas }">
    <article v-for="a in articulos" :key="a.id ?? a.Slug" class="n2-ficha n2-ficha--articulo n2-aparece" :class="{ 'n2-ficha--sin-foto': !a.Imagen }">
      <img v-if="a.Imagen" class="n2-ficha__foto" :src="imagenIDtoSRC(a.Imagen)" :alt="a.Titulo" loading="lazy" />
      <div class="n2-ficha__cuerpo">
        <p class="n2-ficha__meta">
          <time v-if="fechaNotin(a.Fecha)">{{ formatoFecha(a.Fecha) }}</time>
          <span v-if="a.Contenido">{{ tSolicitud('{n} min de lectura', { n: minutosLectura(a.Contenido) }) }}</span>
        </p>
        <component :is="nivel" class="n2-ficha__titulo"><NuxtLink :to="getLocalePath('/blog/' + a.Slug)">{{ a.Titulo }}</NuxtLink></component>
        <p v-if="a.Extracto || a.Contenido">{{ textoPlano(a.Extracto || a.Contenido, 170) }}</p>
        <div v-if="a.Categorias?.length" class="n2-etiquetas">
          <span v-for="c in a.Categorias" :key="c">{{ c }}</span>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup>
import { useUtils } from '#imports'
import { t as tSolicitud, idiomaSolicitud } from '../../composables/solicitudTextos'
import { textoPlano, fechaNotin, minutosLectura } from '../../composables/useNotaria2'

defineProps({
  articulos: { type: Array, default: () => [] },
  columnas: { type: Number, default: 3 },
  /** h2 en la página del blog; h3 bajo otro título. */
  nivel: { type: String, default: 'h2' },
})
const { imagenIDtoSRC, getLocalePath } = useUtils()
const formatoFecha = (f) => new Date(fechaNotin(f)).toLocaleDateString(idiomaSolicitud.value, { year: 'numeric', month: 'long', day: 'numeric' })
</script>
